import { TRANSPORT } from '../../service/enums.js';
import { removeUndefined } from '../../utils/objects.js';
import { BaseWrapperField, } from './BaseWrapperField.js';
import createField from './createField.js';
class ArrayField extends BaseWrapperField {
    minItems;
    maxItems;
    constructor(data) {
        super({ ...data, items: createField(data.items) });
        this.minItems = data.minItems;
        this.maxItems = data.maxItems;
        this.proto.type = `repeated ${this.innerType}`;
    }
    getExample(transport) {
        const innerExample = this.items.getExample(transport);
        return innerExample ? new Array(this.minItems || 1).fill(innerExample) : [];
    }
    toSchema(transport, options) {
        let itemsSchema = this.items.toSchema(transport);
        if (transport === TRANSPORT.GRPC && this.dimensions > 1 && itemsSchema) {
            itemsSchema = {
                type: 'object',
                properties: {
                    [BaseWrapperField.MULTIDIMENSIONAL_FIELD_NAME]: itemsSchema,
                },
                required: [BaseWrapperField.MULTIDIMENSIONAL_FIELD_NAME],
            };
        }
        return removeUndefined({
            ...super.toSchema(transport, options),
            type: 'array',
            minItems: this.minItems,
            maxItems: this.maxItems,
            items: itemsSchema,
        });
    }
    toJSON(input, target) {
        const output = input.map((entry) => this.items.toJSON(entry, target));
        if (target === TRANSPORT.GRPC && this.dimensions > 1) {
            return output.map((entry) => ({
                [BaseWrapperField.MULTIDIMENSIONAL_FIELD_NAME]: entry,
            }));
        }
        return output;
    }
    fromJSON(input) {
        return input?.map((item) => this.items.fromJSON(item));
    }
    fromProto(input) {
        return input?.map((item) => this.items.fromProto(this.dimensions > 1
            ? item[BaseWrapperField.MULTIDIMENSIONAL_FIELD_NAME]
            : item));
    }
}
export default ArrayField;
//# sourceMappingURL=ArrayField.js.map